import { Link } from 'react-router-dom';

const columns = [
  {
    title: '内容分类',
    links: [
      { label: '电影', to: '/movies' },
      { label: '电视剧', to: '/tvshows' },
      { label: '影视资讯', to: '/news' },
      { label: '站内搜索', to: '/search' },
    ],
  },
  {
    title: '热门专题',
    links: [
      { label: '深秋大片清单', to: '/movies' },
      { label: '经典剧集回顾', to: '/tvshows' },
      { label: '迷雾悬疑专题', to: '/movies' },
      { label: '行业动态', to: '/news' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', to: '/about' },
      { label: '团队与愿景', to: '/about' },
      { label: '联系方式', to: '/about' },
      { label: '版权声明', to: '/about' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-[19px]"></i>
              </span>
              <span className="font-heading text-[17px] font-bold text-foreground-950">玩偶姐姐</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              一个专注影视内容聚合与推荐的平台。我们用清晰的分类、真实的推荐和耐心的影评，帮你在海量作品里找到下一部想看的片子。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600">
                <i className="ri-weibo-line text-[16px]"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600">
                <i className="ri-wechat-line text-[16px]"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600">
                <i className="ri-mail-line text-[16px]"></i>
              </span>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-950">
                <span className="inline-block border-b-2 border-accent-500 pb-1">{column.title}</span>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 玩偶姐姐影视内容平台 · 内容为示例演示，不提供播放与下载服务</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="flex items-center gap-1.5">
              <i className="ri-map-pin-line text-[13px]"></i>
              北京市朝阳区影像中心 3 层
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line text-[13px]"></i>
              hello@dollfilm.example
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}